import React from 'react';

/**
 * V4 单段降级横幅。
 *
 * narrative_v4 内每段（含 list 段每个 element）带 degraded: bool。
 * degraded=true 时该段文本是 DEFAULT_REPORT_V4 兜底常量（含 [本段降级] 标记），
 * 顶部统一加这条横幅说明，便于用户区分"AI 生成"与"兜底文案"。
 */
export default function DegradedBanner({ note }) {
  return (
    <div
      data-testid="report-v4-degraded-banner"
      style={{
        background: '#fff7ed',
        border: '1px solid #fdba74',
        color: '#9a3412',
        borderRadius: 6,
        padding: '8px 12px',
        fontSize: 12,
        lineHeight: 1.6,
        marginBottom: 12,
      }}
    >
      <span style={{ fontWeight: 700 }}>本段降级</span>
      {' · '}
      {note || '本段 AI 生成失败，已使用兜底文案。报告其他部分不受影响。'}
    </div>
  );
}
